import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {SwipeablePanel} from "../../../../BaseComponents/SwipeablePanel/SwipeablePanel";
import {SwipeablePanelGripBar} from "../../../../BaseComponents/SwipeablePanel/SwipeablePanelGripBar";
import {RedeemGiftCardView} from "./RedeemGiftCardView";

export function RedeemGiftCardPanel(props) {

    const backdropStyle = {
        position: "fixed",
        top: 0, left: 0, height: "100vh", width: "100vw",
        zIndex: 2000, backgroundColor: "rgba(0,0,0,0.7)"
    }

    return (
        <Fragment>
            <div style={backdropStyle}/>
            <SwipeablePanel
                swipeTreshold={5}
                direction={'top-to-bottom'}
                active={true}
                onDismiss={props.onDismiss}
                animationSpeed={150}
            >
                <SwipeablePanelGripBar className={"bg-main-z2 rounded-top"}/>
                <RedeemGiftCardView
                    secretKey={props.secretKey}
                    onDismiss={props.onDismiss}
                />
            </SwipeablePanel>
        </Fragment>
    );

}

RedeemGiftCardPanel.propTypes = {
    onDismiss: PropTypes.func,
    secretKey: PropTypes.string || PropTypes.number,
}